export default __webpack_public_path__ + "static/media/my-maor-new-logo.b43b5aee.png";